"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewBoxForBBox = void 0;
function viewBoxForBBox(bbox, displayWidth, displayHeight, displayPadding = 0) {
    const paddingX = (displayPadding / displayWidth) * bbox.width;
    const paddingY = (displayPadding / displayHeight) * bbox.height;
    const displayRatio = displayWidth / displayHeight;
    const bboxRatio = bbox.width / bbox.height;
    const minWidth = bbox.width + paddingX * 2;
    const minHeight = bbox.height + paddingY * 2;
    let viewWidth;
    let viewHeight;
    if (displayRatio > bboxRatio) {
        viewHeight = minHeight;
        viewWidth = viewHeight * displayRatio;
    }
    else {
        viewWidth = minWidth;
        viewHeight = viewWidth / displayRatio;
    }
    return [
        bbox.x - (viewWidth - bbox.width) / 2,
        bbox.y - (viewHeight - bbox.height) / 2,
        viewWidth,
        viewHeight,
    ];
}
exports.viewBoxForBBox = viewBoxForBBox;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVmlld0JveFV0aWxzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL1ZpZXdCb3hVdGlscy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUEsU0FBZ0IsY0FBYyxDQUM1QixJQUFpQixFQUNqQixZQUFvQixFQUNwQixhQUFxQixFQUNyQixpQkFBeUIsQ0FBQztJQUUxQixNQUFNLFFBQVEsR0FBRyxDQUFDLGNBQWMsR0FBRyxZQUFZLENBQUMsR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDO0lBQzlELE1BQU0sUUFBUSxHQUFHLENBQUMsY0FBYyxHQUFHLGFBQWEsQ0FBQyxHQUFHLElBQUksQ0FBQyxNQUFNLENBQUM7SUFFaEUsTUFBTSxZQUFZLEdBQUcsWUFBWSxHQUFHLGFBQWEsQ0FBQztJQUNsRCxNQUFNLFNBQVMsR0FBRyxJQUFJLENBQUMsS0FBSyxHQUFHLElBQUksQ0FBQyxNQUFNLENBQUM7SUFFM0MsTUFBTSxRQUFRLEdBQUcsSUFBSSxDQUFDLEtBQUssR0FBRyxRQUFRLEdBQUcsQ0FBQyxDQUFDO0lBQzNDLE1BQU0sU0FBUyxHQUFHLElBQUksQ0FBQyxNQUFNLEdBQUcsUUFBUSxHQUFHLENBQUMsQ0FBQztJQUU3QyxJQUFJLFNBQVMsQ0FBQztJQUNkLElBQUksVUFBVSxDQUFDO0lBQ2YsSUFBSSxZQUFZLEdBQUcsU0FBUyxFQUFFO1FBQzVCLFVBQVUsR0FBRyxTQUFTLENBQUM7UUFDdkIsU0FBUyxHQUFHLFVBQVUsR0FBRyxZQUFZLENBQUM7S0FDdkM7U0FBTTtRQUNMLFNBQVMsR0FBRyxRQUFRLENBQUM7UUFDckIsVUFBVSxHQUFHLFNBQVMsR0FBRyxZQUFZLENBQUM7S0FDdkM7SUFFRCxPQUFPO1FBQ0wsSUFBSSxDQUFDLENBQUMsR0FBRyxDQUFDLFNBQVMsR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQztRQUNyQyxJQUFJLENBQUMsQ0FBQyxHQUFHLENBQUMsVUFBVSxHQUFHLElBQUksQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDO1FBQ3ZDLFNBQVM7UUFDVCxVQUFVO0tBQ1gsQ0FBQztBQUNKLENBQUM7QUEvQkQsd0NBK0JDIn0=